import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MaterialModule} from "./material-module/material.module";
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatButtonModule} from '@angular/material/button';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatIconModule} from '@angular/material/icon';
import {MatListModule} from '@angular/material/list';
import {RouterLink, RouterLinkActive, RouterOutlet} from "@angular/router";
import {MainLayoutComponent} from "./components/app-layout/main-layout/main-layout.component";
import {SharedLayoutComponent} from "./components/app-layout/shared-layout/shared-layout.component";
import {TopBannerComponent} from "./components/app-layout/shared-layout/topbanner/top-banner.component";
import {TopNavBarComponent} from "./components/app-layout/top-nav-bar/top-nav-bar.component";
import {ImportExportPipes} from "./pipes/import-export.pipe";
import {DynamicFormsImportExport} from "./components/dynamic-forms-components/dynamic-forms-import-export";
import {LoaderComponent} from "./components/loader/loader.component";
import {SaveAreaComponent} from "./components/save-area/save-area.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgxPermissionsAllowStubModule, NgxPermissionsModule, NgxPermissionsRestrictStubModule} from "ngx-permissions";
import {PaginatedDataTableComponent} from "./components/paginated-data-table/paginated-data-table.component";
import {ImportExportDirectives} from "./directives/import-export.directives";
import {RegisterComponent} from './components/uaa/register/register.component';
import {ModalHeaderComponent} from './components/modal-header/modal-header.component';
import {PrevNextBtnComponent} from './components/prev-next-btn/prev-next-btn.component';
import {QuickStatsComponent} from "./components/quick-stats/quick-stats.component";
import {ConfirmationDialogComponent} from './components/confirmation-dialog/confirmation-dialog.component';
import {TranslateModule} from "@ngx-translate/core";
import {CdkCell, CdkHeaderCell, CdkHeaderRow, CdkRow, CdkTable} from "@angular/cdk/table";
import {ViewDetailsItemComponent} from "./components/view-details-item/view-details-item.component";
import {DragDropAttachmentComponent} from './components/drag-drop-attachment/drag-drop-attachment.component';
import {ProgressComponent} from './components/progress/progress.component';
import {StaffLoginComponent} from './components/uaa/staff-login/staff-login.component';
import {PdfViewerComponent} from './components/pdf-viewer/pdf-viewer.component';
import {NgxExtendedPdfViewerModule} from "ngx-extended-pdf-viewer";
import {ViewPdfInPopupComponent} from './components/view-pdf-in-popup/view-pdf-in-popup.component';
import {QuillEditorComponent} from "ngx-quill";
import {EmptyDataComponent} from './components/empty-data/empty-data.component';
import {AttachmentChipComponent} from './components/attachment-chip/attachment-chip.component';
import {InfoComponent} from './components/info/info.component';
import {RecoverPasswordComponent} from './components/uaa/recover-password/recover-password.component';
import {
  SessionTimeoutWarnDialogComponent
} from './components/session-timeout-warn-dialog/session-timeout-warn-dialog.component';
import {FilterButtonsComponent} from "./components/filter-buttons/filter-buttons.component";
import {ItemWithTipComponent} from './components/item-with-tip/item-with-tip.component';
import {NgApexchartsModule} from "ng-apexcharts";
import {NgxMaskDirective, NgxMaskPipe} from 'ngx-mask';
import {NotAllowedComponent} from './components/not-allowed/not-allowed.component';
import {SafeHtmlPipe} from "./pipes/safe-html.pipe";
import {SplitPipe} from "./pipes/split.pipe";
import {ValueIncludesPipe} from "./pipes/value-includes.pipe";
import {ToFixedPipe} from "./pipes/to-fixed.pipe";
import {RoundPipe} from "./pipes/round.pipe";
import {ArrayToStringPipe} from "./pipes/array-to-string.pipe";
import {StrLimitPipe} from "./pipes/str-limit.pipe";
import {StringWrappedInPipe} from "./pipes/string-wrapped-in.pipe";
import {ReadDotPropertyPipe} from "./pipes/read-dot-property.pipe";
import {StringBetweenPipe} from "./pipes/string-between.pipe";
import {SearchPipe} from "./pipes/search.pipe";
import {DynamicPipe} from "./pipes/dynamic.pipe";
import {FormatNumberPipe} from "./pipes/format-number.pipe";
import {SafeResourcePipe} from "./pipes/safe-resource.pipe";
import {IconTypePipe} from "./pipes/icon-type.pipe";
import {TruncatePipe} from "./pipes/truncate.pipe";
import {PushPipe} from "./pipes/push.pipe";
import {ShortNumberPipe} from "./pipes/short-number.pipe";
import {CamelToTitleCasePipe} from "./pipes/camel-to-title-case.pipe";
import {CountingPipe} from "./pipes/counting.pipe";
import {ObservablePipe} from "./pipes/observable.pipe";
import {LengthPipe} from "./pipes/length.pipe";
import {CountPipe} from "./pipes/count.pipe";
import {ReplacePipe} from "./pipes/replace.pipe";
import {ActionButtonsComponent} from "./components/app-layout/top-nav-bar/action-buttons/action-buttons.component";
import {MtxGrid} from "@ng-matero/extensions/grid";
import {NgxParticlesModule} from "@tsparticles/angular";
import {TopNavRightBarComponent} from './components/app-layout/top-nav-right-bar/top-nav-right-bar.component';
import {TopNavMenuItemComponent} from './components/app-layout/top-nav-menu-item/top-nav-menu-item.component';
import {CarouselModule} from "primeng/carousel";
import {CustomStepperComponent} from './components/custom-stepper/custom-stepper.component';
import {NgxTimelineModule} from "@frxjs/ngx-timeline";
import {NgxMatTimelineModule} from "ngx-mat-timeline";
import {ViewMapComponent} from "./components/view-map/view-map.component";

import {ImageCropperModalComponent} from './components/image-cropper-modal/image-cropper-modal.component';
import {ImageCropperComponent} from "ngx-image-cropper";
import {NoDataComponent} from "./components/no-data/no-data.component";
import {TabLayoutComponent} from "./components/tab-layout/tab-layout.component";
import {
  NotificationListComponent
} from "./components/app-layout/main-layout/notification-list/notification-list.component";
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { SummaryCardsComponent } from './components/dashboard/summary-cards/summary-cards.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BarGraphComponent } from './components/graphs/bar-graph/bar-graph.component';
import { SummaryCardsVariantComponent } from './components/dashboard/summary-cards-variant/summary-cards-variant.component';
import {RemoveUnderscorePipe} from "./pipes/remove-underscore.pipe";
import {NoContentComponent} from "./components/no-content/no-content.component";
import {LoadingContentComponent} from "./components/loading-content/loading-content.component";
import {NgHttpLoaderComponent} from "ng-http-loader";
import { ReportSelectorComponent } from './components/report-selector/report-selector.component';
import { RadialbarsGraphComponent } from './components/graphs/radialbars-graph/radialbars-graph.component';
import {HeatmapGraphComponent} from "./components/graphs/heatmap-graph/heatmap-graph.component";
import { CarouselComponent } from './components/carousel/carousel.component';
import { HighChartMapComponent } from './components/high-chart-map/high-chart-map.component';
import {HighchartsChartModule} from "highcharts-angular";
import { ReusableBarChartComponent } from './components/graphs/reusable-bar-chart/reusable-bar-chart.component';


const PIPES = [
  SplitPipe, ValueIncludesPipe, ToFixedPipe, RoundPipe, ArrayToStringPipe, StrLimitPipe, StringWrappedInPipe, ReadDotPropertyPipe,
  ReplacePipe, CountPipe, LengthPipe, ObservablePipe, CamelToTitleCasePipe, StringBetweenPipe, TruncatePipe, SafeHtmlPipe, FormatNumberPipe,
  SearchPipe, DynamicPipe, SafeResourcePipe, IconTypePipe, PushPipe, ShortNumberPipe, CountingPipe, RemoveUnderscorePipe,
]


const declarations = [
  // Components
  MainLayoutComponent,
  SharedLayoutComponent,
  TopBannerComponent,
  LoaderComponent,
  SaveAreaComponent,
  PaginatedDataTableComponent,
  PrevNextBtnComponent,
  QuickStatsComponent,
  ViewDetailsItemComponent,
  ModalHeaderComponent,
  DragDropAttachmentComponent,
  ProgressComponent,
  PdfViewerComponent,
  ViewPdfInPopupComponent,
  EmptyDataComponent,
  InfoComponent,
  FilterButtonsComponent,
  AttachmentChipComponent,
  RecoverPasswordComponent,
  SessionTimeoutWarnDialogComponent,
  ItemWithTipComponent,
  SessionTimeoutWarnDialogComponent,
  ActionButtonsComponent,
  ViewMapComponent,
  NoDataComponent,
  TabLayoutComponent,
  NotificationListComponent,
  LandingPageComponent,
  BarGraphComponent,
  RadialbarsGraphComponent,
  NoContentComponent,
  LoadingContentComponent,
  HeatmapGraphComponent,
  CarouselComponent,
  HighChartMapComponent,
  // Dynamic form components
  ...DynamicFormsImportExport,

  // Pipes
  ...ImportExportPipes,

  // Directives
  ...ImportExportDirectives,

  ...PIPES
]

@NgModule({
  declarations: [
    ...declarations,
    TopNavBarComponent,
    RegisterComponent,
    ConfirmationDialogComponent,
    StaffLoginComponent,
    NotAllowedComponent,
    TopNavRightBarComponent,
    TopNavMenuItemComponent,
    CustomStepperComponent,
    ImageCropperModalComponent,
    SummaryCardsComponent,
    SummaryCardsVariantComponent,
    ReportSelectorComponent,
    CarouselComponent,
    HighChartMapComponent,
    ReusableBarChartComponent,

  ],
  imports: [
    CommonModule,
    MaterialModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    RouterOutlet,
    RouterLinkActive,
    RouterLink,
    ReactiveFormsModule,
    NgApexchartsModule,
    FormsModule,
    NgxPermissionsModule.forChild(),
    NgxPermissionsRestrictStubModule,
    NgxExtendedPdfViewerModule,
    TranslateModule,
    CarouselModule,
    CdkTable,
    CdkHeaderCell,
    CdkCell,
    CdkHeaderRow,
    CdkRow,
    QuillEditorComponent,
    NgxMaskDirective,
    NgxMaskPipe,
    MtxGrid,
    NgxParticlesModule,
    NgxTimelineModule,
    NgxMatTimelineModule,
    ImageCropperComponent,
    FontAwesomeModule,
    NgHttpLoaderComponent,
    HighchartsChartModule,

  ],
  exports: [
    ...declarations,
    MaterialModule,
    NgxPermissionsModule,
    NgxPermissionsAllowStubModule,
    NgxPermissionsRestrictStubModule,
    ReactiveFormsModule,
    NgApexchartsModule,
    AttachmentChipComponent,
    ItemWithTipComponent,
    NotAllowedComponent,
    NoDataComponent,
    ViewMapComponent,
    TabLayoutComponent,
    NgxMaskDirective,
    NgxMaskPipe,
    SummaryCardsComponent,
    FontAwesomeModule,
    SummaryCardsVariantComponent,
    ReportSelectorComponent,
  ]
})
export class SharedModule {
}
